module.exports = __webpack_public_path__ + "img/icon-low-price.9983a600.svg";